import styled from 'styled-components';
import CategoriesBlock from '@components/categories-bar';
import Text from '@components/text';

export const ImageContainer = styled.div`
  width: 100%;
  justify-content: stretch;
  align-items: stretch;
  border-radius: 1rem;
  overflow: hidden;

  div {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

export const Title = styled(Text)`
  font-size: 2.75rem;
  line-height: 3rem;
`;

export const CategoriesBlog = styled(CategoriesBlock)`
  margin-bottom: -2.3125rem;
`;

export const CategoriesPost = styled(CategoriesBlock)`
  margin-top: 4rem;
`;
